import { jwtDecode } from 'jwt-decode';

let logoutTimer = null;

export function scheduleTokenExpiration(token, onExpire = () => {
  localStorage.removeItem('velaToken');
  window.location.href = '/login';
}) {
  try {
    const { exp } = jwtDecode(token);
    const timeLeft = exp * 1000 - Date.now();

    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }

    logoutTimer = setTimeout(onExpire, timeLeft);
  } catch (err) {
    console.warn('Unable to decode JWT for expiration:', err);
    onExpire();
  }
}

export function clearScheduledLogout() {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }
}
